import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doLogin } from './Web3Service';
import { json } from 'stream/consumers';

function Login() {

  const navigate = useNavigate();

  const [message, setMessage] = useState("");

  useEffect(() => {

    if(localStorage.getItem("account") !== null)
      redirectAfterLogin(localStorage.getItem("isAdmin") === "true");

  }, []);

  function redirectAfterLogin(isAdmin: boolean){

    if(isAdmin)
      navigate("/admin");
    else
      navigate("/app");

  }

  function onBtnClick(){

    setMessage("Logging in ...");
    doLogin()
      .then(result => redirectAfterLogin(result.isAdmin))
      .catch(err => setMessage(err.message));

  }

  return (
    <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">

      <header className="mb-auto">
        <div>
          <h3 className="float-md-start mb-0">DApp Odd or Even</h3>
          <nav className="nav nav-masthead justify-content-center float-md-end">
            <a className="nav-link fw-bold py-1 px-0 active" aria-current="page" href="#">Home</a>
            <a className="nav-link fw-bold py-1 px-0" href="#">About</a>
          </nav>
        </div>
      </header>

      <main className="px-3">
        <img className='d-block mx-auto mb-2' src='./logo512.png' alt='OddOrEven' width={144}/>
        <h4>Log in with your Metamask and Play</h4>
        <p className="lead">Bet Odd or Even (BSC TestNet)</p>
        <p className="lead">
          <a href="#" onClick={onBtnClick} className="btn btn-lg btn-light fw-bold border-white bg-white">
            <img src='/assets/metamask.svg' alt='MetaMask Logo' width="48" />
            Login
          </a>
        </p>

        <p className="lead">
          {message}
        </p>
      </main>

      <footer className="mt-auto text-white-50">
        <p>Built by <a href="https://github.com/carlosamcruz" className="text-white" target="_blank" rel="noopener noreferrer">Carlos Cruz</a></p>
        <p>Contract <a href="https://testnet.bscscan.com/address/0xae42E1727B170FE607128c9b972EA855bD859850#code" 
        className="text-white" target="_blank" rel="noopener noreferrer" >
          0xae42e1727b170fe607128c9b972ea855bd859850 (BSC TestNet) </a></p>
      </footer>
    </div>
  );
}

export default Login;